import React from "react";
import { withRef, withVariants } from "@udecode/cn";
import { PlateElement } from "@udecode/plate-common";
import { cva } from "class-variance-authority";

const headingVariants = cva("", {
  variants: {
    variant: {
      h1: "mb-1 pt-[0.75em] font-heading font-sans text-4xl font-bold",
      h2: "mb-px pt-[0.5em] font-heading font-sans text-2xl font-semibold tracking-tight",
      h3: "mb-px pt-[0.5em] font-heading font-sans text-xl font-semibold tracking-tight",
      h4: "pt-[0.5em] font-heading text-lg font-semibold tracking-tight",
      h5: "pt-[0.5em] text-lg font-semibold tracking-tight",
      h6: "pt-[0.5em] text-base font-semibold tracking-tight",
    },
    isFirstBlock: {
      true: "mt-0",
      false: "",
    },
  },
});

const HeadingElementVariants = withVariants(PlateElement, headingVariants, [
  "isFirstBlock",
  "variant",
]);

export const HeadingElement = withRef<typeof HeadingElementVariants>(
  ({ variant = "h1", isFirstBlock, children, ...props }, ref) => {
    const { element, editor } = props;

    const Element = variant!;

    return (
      <HeadingElementVariants
        ref={ref}
        asChild
        variant={variant}
        isFirstBlock={element === editor.children[0]}
        {...props}
      >
        <Element>{children}</Element>
      </HeadingElementVariants>
    );
  },
);
